import React, { useState, useEffect, useCallback } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import TechnicalSkills from "./components/TechnicalSkills/TechnicalSkills";
import ProfessionalExperience from "./components/ProfessionalExperience/ProfessionalExperience";
import FeaturedProjects from "./components/FeaturedProjects/FeaturedProjects";
import LetsConnect from "./components/LetsConnect/LetsConnect";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [load, upadateLoad] = useState(true);

  // Memoize the timer cleanup function
  const handleLoadComplete = useCallback(() => {
    upadateLoad(false);
  }, []);

  useEffect(() => {
    const timer = setTimeout(handleLoadComplete, 1200);

    return () => clearTimeout(timer);
  }, [handleLoadComplete]);

  return (
    <>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Home />
        <About />
        <TechnicalSkills />
        <ProfessionalExperience />
        <FeaturedProjects />
        <LetsConnect />
        <Footer />
      </div>
    </>
  );
}

export default React.memo(App);
